import React, { useState } from "react";
import ImageDevOpsAutomation from "../../images/DevOps-Automation.jpg";
import ImageCloudDevops from "../../images/Cloud-Icon.png";
import IconDevOpsAutomation from "../../icons/icon-devOps-automation.svg";
import IconEnterpriseSecurity from "../../icons/icon-enterprise-security-cs.svg";
import IconMassivelyScalable from "../../icons/icon-massively-scalable.svg";
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import { motion } from 'framer-motion';
import Parallax from "../common/utils/animations/parallax";
import LazyLoad from 'react-lazyload';

export default function CsDevOpsAutomation() {
  const [isVisible, setisVisible] = useState(false);
  const variants = {
    hidden: {
      opacity: 0,
      scale: 0.5,
      x: -107
    },
    show: {
      opacity: 1,
      scale: 1,
      x: 0
    }
  };
  return (
    <InView as="div" className="cs-devops-section section-gap" onChange={(inView) => setisVisible(inView)} threshold={[0.15]}>
      <div className="container">
        <div className="row d-flex flex-wrap">
          <div className="col cs-devops-content">
            <motion.div
              className="cloud-icon"
              initial="hidden"
              animate={isVisible ? "show" : "hidden"}
              variants={variants}
            >
              <img src={ImageCloudDevops} width="107px" className="cb-api-platform" title="cloud-native architecture" alt="cloud native architecture" />
            </motion.div>
            <p className="theme-color-title light-blue-color">{isVisible ? <HeaderAnim header="NEXT-GEN CLOUD & DEVOPS" /> : ""}</p>
            <h3>Cloud-Native Architecture</h3>
            <p>Salesmate is the primary system for all customer information and communication. Any downtime, even for minutes, stops thousands of sales reps’ from selling. The stakes are high. </p>

            <p>Hence, we had to adhere to the highest standards of reliability, performance, and scalability. We built a world-class infrastructure and architecture on Google Cloud Platform that automatically scales on-demand and restores from failures without human interventions.</p>
          </div>

          <div className="col cs-devops-image">
            <LazyLoad>
              <img src={ImageDevOpsAutomation} className="cb-devops-automation" title="cloud native architecture" alt="cloud-native architecture" />
            </LazyLoad>
          </div>
        </div>

        <div className="grid-layout-section-style-2">
          <div className="row d-flex flex-wrap">
            <Parallax classes="col grid-item-style-2" id={"grid-item-devops-1"} triggers={[1, 0.8]} opacity={true} length={50}>
              <div className="item-inner">
                <div className="grid-icon-left">
                  <i className="icon-small"><IconDevOpsAutomation /></i>
                </div>
                <h4 className="h3">DevOps Automation</h4>
                <p>We enabled automated build pipelines, deployments, and scaling of 140+ microservices using Kubernetes.</p>
              </div>
            </Parallax>
            <Parallax classes="col grid-item-style-2" id={"grid-item-devops-2"} triggers={[1, 0.8]} opacity={true} length={50}>
              <div className="item-inner">
                <div className="grid-icon-left">
                  <i className="icon-small"><IconMassivelyScalable /></i>
                </div>
                <h4 className="h3">Massively Scalable</h4>
                <p>We vetted technologies and designed architectures to ensure that the entire platform is fully distributed and horizontally scalable.</p>
              </div>
            </Parallax>
            <Parallax classes="col grid-item-style-2" id={"grid-item-devops-3"} triggers={[0.9, 0.7]} opacity={true} length={50}>
              <div className="item-inner">
                <div className="grid-icon-left">
                  <i className="icon-small"><IconEnterpriseSecurity /></i>
                </div>
                <h4 className="h3">Enterprise Security</h4>
                <p>Salesmate stores the most sensitive PII data for all users. We secured it with enterprise security that is certified by industry vendors.</p>
              </div>
            </Parallax>
          </div>
        </div>
      </div>
    </InView>
  );
}